import IDataAccessObjectProperties from '../../../../../../core/DAL/DAO/IDataAccessObjectProperties';

export default class CreateBundleDAOProperties extends IDataAccessObjectProperties {

	constructor() {

		let path = 'release_bundle';
		let paramDefaults = {};
		let customActions = {
			createReleaseBundle: {
				method: 'POST',
				notifications: true
			},
			updateReleaseBundle: {
				url: `${path}/:release_bundle/:release_bundle_version`,
				method: 'PUT',
				notifications: true
			},
			dryRun: {
				method: 'POST',
				notifications: false
			},
			queryDryRun: {
				method: 'POST',
				url: `${path}/spec_preview`,
				isArray: true
			},
			getReposInArtifactory: {
				method: 'GET',
				url: `${path}/repositories`,
				isArray: true
			}
		};

		super(path, paramDefaults, null, customActions);
	}
};

CreateBundleDAOProperties.META = {
	name: 'CreateBundleDAOProperties'
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/DAO/CreateBundleDAOProperties.js